import { highlightTermsHtml } from "@/lib/topicSearch";

/** Multi-term highlight for local topic search. */
export default function TopicHighlight({ text, terms, className = "" }) {
  if (!text) return null;
  if (!terms?.length) return <span className={className}>{text}</span>;
  const html = highlightTermsHtml(text, terms);
  if (!html.includes("<mark")) return <span className={className}>{text}</span>;
  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: html }} />
  );
}
